import React, { Fragment } from "react";

import PromoText from "./PromoText";
import MealList from "./MealList";

const Meals = () => {
    return (
        <Fragment>
            <PromoText />
            <MealList />
        </Fragment>
    );
}
export default Meals;